import React from 'react'
import Helmet from 'react-helmet'
import styled from 'styled-components'
import media from '../styles/media'
import Header from '../components/Header'
import Footer from '../components/Footer'
import Service from '../components/Service'
import New from '../components/New'
import Bottom from '../components/Bottom'
import { FormattedMessage, injectIntl } from 'gatsby-plugin-intl'

import Carousel from '../components/Carousel'
import Somos from '../components/Somos'
import { graphql } from 'gatsby'
import { convertStringToSlug } from '../utils/helpers'
import BackServices from '../assets/images/fondo-servicios.jpg'

import '../assets/css/fonts.css'
import '../assets/css/bootstrap.min.css'

const ContainerServices = styled.div`
    background-image: url(${BackServices});
    margin: 0;
    padding: 0;
    text-align: center;
    padding: 0;
    
  .titleHomeServices{
    color: #fff;
    font-size: 35px;
    font-family: 'Prelo Slab';
    text-align: center;
  }
    ${media.sm`
        font-size: 22px;
    `};

`

const TitleHomeNews = styled.p`
  color: #0000e2;
  font-size: 35px;
  font-family: 'Prelo Slab';
  text-align: center;
`
const Container = styled.div`
`
const BoxShadow = styled.div`
-webkit-filter: drop-shadow(-1px 6px 3px rgba(0,0,0,.18));
filter: drop-shadow(-1px 6px 3px rgba(0,0,0,.18));
  .botonesNews {
    background-color: #e5b701;
    border-top: 0px solid transparent;
    padding: 7px;
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
    font-size:14px;
  }
  .NewsContainer {
    margin: 0 80px;
    padding: 0;
    text-align: center;
    padding-bottom: 25%;
    box-shadow: 0 7px 20px 0 rgba(0, 0, 0, 0.18);
    clip-path: polygon(0 0, 100% 0, 100% 61%, 50% 80%, 0 56%);
    background: #fff;
    box-sizing: border-box;
    ${media.sm`
      background: none;
      clip-path: none;
      margin: auto;
      box-sizing: none;
      box-shadow: none;
    `};
  }

  .centerBox {
    display: flex;
    justify-content: center;
    align-items: center;
    bottom: 8%;
  }

  .MoreInfoNews {
    background: #fac700;
    padding: 6px;
    font-size: 16px;
    height: 34px;
    width: 200px;
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
    & a {
      color: #404040;
    }
  }

  ${media.sm`
    filter: none;
  `};
`

class Home extends React.Component {
  onServicePress = modalContent => {
    this.setState({
      isModalOpen: true,
      modalContent
    })
  }

  render() {
    const Services = this.props.data.allServicesJson.edges.map(({ node }, index) => {
      const image = this.props.data.allFile.edges.find(file => {
        return file.node.relativePath === `${convertStringToSlug(node.service)}.jpg`
      })
      if (this.props.intl.locale === 'es') {
        return (
          <Service
            id={node.id}
            more={node.es.more}
            name={node.es.name}
            description={node.es.description}
            key={node.id}
            image={image}
            onServicePress={this.onServicePress}
          />
        )
      } else {
        return (
          <Service
            id={node.id}
            more={node.en.more}
            name={node.en.name}
            description={node.en.description}
            key={node.id}
            image={image}
            onServicePress={this.onServicePress}
          />
        )
      }
    })

    const News = this.props.data.allNewsJson.edges.map(({ node }, index) => {
      const image = this.props.data.allFile.edges.find(file => {
        return file.node.relativePath === `${convertStringToSlug(node.new)}.jpg`
      })
      if (parseInt(node.idN, 10) <= 2) {
        if (this.props.intl.locale === 'es') {
          return (
            <a href={"/es/blog/noticia_"+node.idN}>
              <New
                id={node.idN}
                name={node.es.name}
                description={node.es.descriptionN}
                date={node.es.date}
                key={node.idN}
                image={image}
                onServicePress={this.onServicePress}
              />
            </a>
          )
        } else {
          return (
            <a href={"/es/blog/noticia_"+node.idN}>
              <New
                id={node.idN}
                name={node.en.name}
                description={node.en.descriptionN}
                date={node.en.date}
                key={node.idN}
                image={image}
                onServicePress={this.onServicePress}
              />
            </a>
          )
        }
      }
    })
    return (
      <Container>
        <Helmet>
          <title>Almesa :: Banco Pichincha</title>
        </Helmet>
        <Header />
        <Carousel />
        <Somos />
        <ContainerServices className="fondoServicios ServicesContainer">
          <p className="titleHomeServices">
            <FormattedMessage id="MenuServicios" />
          </p>
          {Services}
        </ContainerServices>

        <TitleHomeNews>
          <FormattedMessage id="pageHomeNoticias" />
        </TitleHomeNews>
        <BoxShadow>
          <div className="clip-each border-style-thin NewsContainer">
            {News}
            <div className="centerBox">
              <div className="MoreInfoNews">
                <a href="noticias">
                  <FormattedMessage id="pageHomeTodasNoticias" />
                </a>
              </div>
              <span className="botonesNews">
                <i className="demo-icon icon-iconos-almesa-08">&#xe807;</i>
              </span>
            </div>
          </div>
        </BoxShadow>
        <Bottom />
        <Footer />
      </Container>
    )
  }
}

export const query = graphql`
  query ContentQuery {
    allNewsJson(sort: { fields: [idN], order: ASC }) {
      edges {
        node {
          idN
          new
          es {
            name
            descriptionN
            date
          }
          en {
            name
            descriptionN
            date
          }
        }
      }
    }

    allServicesJson(sort: { fields: [id], order: ASC }) {
      edges {
        node {
          id
          service
          es {
            name
            description
          }
          en {
            name
            description
          }
        }
      }
    }

    allFile(filter: { sourceInstanceName: { eq: "images" }, extension: { eq: "jpg" } }) {
      edges {
        node {
          relativePath
          childImageSharp {
            resolutions(width: 488, quality: 70) {
              ...GatsbyImageSharpResolutions
            }
          }
        }
      }
    }
  }
`

export default injectIntl(Home)
